<template>
  <div class="event-card -shadow">
    <router-link
      class="event-link"
      :to="{ name: 'event-show', params: { id: event.id } }"
    >
      <span class="eyebrow">{{ event.time }} at {{ event.date }}</span>
      <h4 class="title">{{ event.title }}</h4>
      <BaseIcon name="users">{{ event.attendees.length }}</BaseIcon>
      <BaseButton></BaseButton>
      <BaseButton>Submit</BaseButton>
      <BaseButton>Save {{ event.title }}</BaseButton>
    </router-link>
    <div>
      <BaseMediaBox>
        <h2 slot="heading">My bio</h2>
        <template slot="paragraph">
          <p>putting a button in a template:</p>
          <BaseButton></BaseButton>
        </template>
      </BaseMediaBox>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    event: Object
  },
  created() {
    this.$store.commit('INCREMENT_COUNT', 1)
  }
}
</script>

<style scoped>
.event-card {
  padding: 20px;
  margin-bottom: 24px;
  transition: all 0.2s linear;
  cursor: pointer;
}
.event-card:hover {
  transform: scale(1.01);
  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.2), 0 1px 15px 0 rgba(0, 0, 0, 0.19);
}
.event-card > .title {
  margin: 0;
}

.event-link {
  color: black;
  text-decoration: none;
  font-weight: 100;
}
</style>
